<template>
  <v-main>
    <Cdrs />
  </v-main>
</template>

<script>
import Cdrs from '@/components/cdrs'
export default {
  name: 'cdrs-settings',
  components: { Cdrs }
}
</script>

<style scoped>
</style>
